/**
 * Store global breakpoints for use across the whole project.
 */
 const breakpoints = {
    sm: 375,
    md: 768,
    ls: 1024,
    dp: 1200,
    lg: 1440,
    xl: 1600
};

module.exports = breakpoints;
